const updates = [
  { time: '10分钟前', title: '某女星深夜发长文回应恋情传闻，言辞恳切引热议', tag: '新' },
  { time: '28分钟前', title: '热播综艺节目录制现场突发状况，导演紧急叫停', tag: '新' },
  { time: '1小时前', title: '某知名导演新片选角争议，网友质疑选角标准', tag: '热' },
  { time: '2小时前', title: '明星夫妻被拍同框，力破婚变传闻', tag: '' },
  { time: '3小时前', title: '年度音乐颁奖礼提名公布，多位歌手意外落选', tag: '' },
  { time: '5小时前', title: '网红直播带货数据造假被平台处罚，账号封禁30天', tag: '热' },
  { time: '7小时前', title: '某剧组片场路透曝光，造型引粉丝集体吐槽', tag: '' },
  { time: '9小时前', title: '前爱豆转型演员首部作品定档，粉丝期待值拉满', tag: '' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时追踪全网吃瓜动态，不错过任何一条热门资讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="relative flex gap-4 pb-5 last:pb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500 mt-1.5 flex-shrink-0"></div>
                {i < updates.length - 1 && (
                  <div className="w-0.5 flex-1 bg-primary-200 mt-1"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  {item.tag && (
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                      item.tag === '热' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}